import L from "leaflet";
import { renderToString } from "react-dom/server";
import { AirQualityStationType } from "@/db/definitions";
import { twMerge } from "tailwind-merge";
import IconAirStation from "@/components/icon/IconAirStation";

const markerColors: Record<AirQualityStationType, string> = {
  REGIONAL: "bg-sky-300",
  MUNICIPAL: "bg-emerald-300",
  TRAFFIC: "bg-amber-300",
  INDUSTRIAL: "bg-zinc-300",
  OTHER: "bg-indigo-300",
};

export function getAirStationMarkerIcon(type: AirQualityStationType) {
  const html = renderToString(
    <div
      className={twMerge(
        "text-primary rounded-full flex items-center justify-center w-7 h-7 border border-primary",
        markerColors[type]
      )}
    >
      <IconAirStation type={type} className="w-4 h-4" />
    </div>
  );

  return L.divIcon({
    html,
    className: "",
    iconSize: [28, 28],
  });
}
